import { useState } from 'react';
import { Download, Check } from 'lucide-react';
import { exportToCSV } from '../../utils/export';
import styles from './ExportButton.module.css';

function ExportButton({
    data,
    filename = 'export',
    columns = null,
    label = 'Export CSV',
    disabled = false,
}) {
    const [isSuccess, setIsSuccess] = useState(false);

    const handleExport = () => {
        if (!data || data.length === 0) return;

        const result = exportToCSV(data, filename, { columns });

        if (result?.success) {
            setIsSuccess(true);
            setTimeout(() => setIsSuccess(false), 2000);
        }
    };

    return (
        <button
            className={`${styles.exportButton} ${isSuccess ? styles.success : ''}`}
            onClick={handleExport}
            disabled={disabled || !data || data.length === 0}
        >
            {isSuccess ? (
                <>
                    <Check size={16} />
                    <span>Exported!</span>
                </>
            ) : (
                <>
                    <Download size={16} className={styles.icon} />
                    <span>{label}</span>
                </>
            )}
        </button>
    );
}

export default ExportButton;
